import YesNoModal from './Modal';

export default YesNoModal;
